import React from 'react';
import { Row, Col, Table, Form, Spinner } from 'react-bootstrap';
import Pagination from 'react-js-pagination';
import { useTranslation, Trans } from 'react-i18next';
import { DebounceInput } from 'react-debounce-input';

import { CurrencyPlainText } from 'helpers/Currency';
import { parseDateBR } from 'helpers/date';
import flatten from 'helpers/flatten';

const ListingReports = ({
  reports,
  fields,
  filters,
  stateFilters,
  handleFilterChange,
  load
}) => {
  const { t } = useTranslation();
  const handlePageChange = page => handleFilterChange({ page });
  return (
    <>
      <Row>
        <Col>
          <Row className="justify-content-end">
            {filters.map((filter, k) => (
              <Col key={k} md={3}>
                <Form.Group>
                  <Form.Label>{t(`label:${filter.name}`)}</Form.Label>
                  <Form.Control
                    value={stateFilters[filter.key]}
                    onChange={e =>
                      handleFilterChange({
                        [filter.key]: e.target.value,
                        page: 1
                      })
                    }
                    as="select"
                  >
                    <option value="">{t('label:all')}</option>
                    {filter.options.map((option, k) => (
                      <option key={k} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            ))}
          </Row>
          <Row>
            <Col md={3}>
              <Form.Group>
                <Form.Label>{t('label:records per page')}:</Form.Label>
                <Form.Control
                  as="select"
                  value={stateFilters.per_page}
                  onChange={e =>
                    handleFilterChange({ per_page: e.target.value, page:1 })
                  }
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={3} className="ml-auto">
              <Form.Group>
                <Form.Label>{t('label:search')}:</Form.Label>
                <DebounceInput
                  element={Form.Control}
                  debounceTimeout={500}
                  value={stateFilters.__search}
                  onChange={e => handleFilterChange({ __search: e.target.value, page:1 })}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Table bordered hover responsive id="general-report-table">
                <thead>
                  <tr>
                    {fields.map((field, k) => (
                      <th className="text-center align-middle" key={k}>
                        {t(`label:${field.name}`)}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {load?
                  <tr><td colSpan={fields.length} className="text-center">
                    <Spinner animation="border" role="status">
                      <span className="sr-only">Loading...</span>
                    </Spinner>
                  </td></tr>
                  :<>
                  {reports.data.map((report, k) => {
                    const data = flatten(report);
                    return (
                      <tr key={k}>
                        {fields.map((field, k) => {
                          let text = 0;
                          if(field.mask){
                            return (
                              <td className="text-center align-middle" key={k}>
                                {field.mask(report)}
                              </td>
                            );
                          }
                          switch (field.type) {
                            case 'string':
                              text = !!data[field.key] ? data[field.key] : '--';
                              break;
                            case 'date':
                              text = !!data[field.key]
                                ? parseDateBR(data[field.key])
                                : '--';
                              break;
                            case 'currency':
                              text = !!data[field.key] ? (
                                <CurrencyPlainText
                                  value={parseFloat(data[field.key])}
                                />
                              ) : (
                                '--'
                              );
                              break;
                            case 'collected':
                              report.funds.map(fund => {
                                text += parseInt(fund.value_currency_real);
                              });
                              text = text.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                              });
                              break;
                            case 'invoiced amount':
                              report.actions.map(action => {
                                if(action.status_id == 17 || action.status_id == 18){
                                  action.all_values.map(value => {
                                    text += parseInt(value.real_value)
                                  });
                                }
                              });
                              text = text.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                              });
                              break;
                            case 'total spent':
                              report.actions.map(action => {
                                action.all_values.map(value => {
                                  text =
                                    action.status_id !== 19
                                      ? (text += parseInt(value.actual_value))
                                      : 0;
                                });
                              });
                              text = text.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                              });
                              break;
                            case 'margin':
                              let margin = 0;

                              report.actions.map(action => {
                                  margin += action.margin.margin;
                              });

                              // margin = collected - spent - expire;
                              text += margin;
                              text = text.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                              });
                              break;
                            case 'received':
                              let assign = 0;
                              report.actions.map(action => {
                                action.refunds.map(value => {
                                  assign += value.value
                                });
                              });
                              text += assign;
                              text = text.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                              });
                              break;
                            case 'to profit':
                              let profit = 0;
                              let received = 0;
                              report.actions.map(action => {
                                action.all_values.map(value => {
                                  if (action.status_id === 13) {
                                    profit += parseInt(value.actual_value);
                                  } 
                                  // else if (action.status_id === 18) {
                                  //   received += parseInt(value.actual_value);
                                  // }
                                });
                              });

                              if (profit !== 0) {
                                text += profit;
                              } 
                              // else {
                              //   text += received;
                              // }

                              text = text.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                              });
                              break;
                            case 'two_string':
                              var text_list = field.key.split('|')
                              text = data[text_list[0]];
                              for (let index = 1; index < text_list.length; index++) {
                                text += ' / '+data[text_list[index]];
                              }
                              break;
                            default:
                              text = data[field.key];
                              break;
                          }

                          if (!!field.trans) text = t(`${field.name}:${text}`);

                          return (
                            <td className="text-center align-middle" key={k}>
                              {text}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                  </>}
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row>
            <Col>
              <Trans i18nKey="label:interpolateShowingRecords">
                Showing {{ from: reports.pagination.from || '0' }} to{' '}
                {{ to: reports.pagination.to || '0' }} from {{ total: reports.pagination.total }}{' '}
                records
              </Trans>
            </Col>
            <Col className="d-flex justify-content-end">
              <Pagination
                activePage={reports.pagination.current_page}
                itemsCountPerPage={reports.pagination.per_page}
                totalItemsCount={reports.pagination.total}
                pageRangeDisplayed={5}
                onChange={handlePageChange}
                itemClass="page-item"
                linkClass="page-link"
                prevPageText="‹"
                nextPageText="›"
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default ListingReports;
